import { lazy } from 'react'
import { useSelector } from 'react-redux'

import { Spinner } from '~/shared/components/Spinner'
import {
  SubscriptionListType,
  SubscriptionTag,
} from '~/shared/constants/commonConstants'
import { PageId } from '~/shared/constants/pagesConstants'
import { useGetSubscriptions } from '~/shared/hooks/useGetSubscriptions'
import { ScreenName } from '~/shared/services/eventLogger'
import { selectAreSubscriptionsReady } from '~/shared/store/payment/selects'
import { PageProps, TIdToPageMap } from '~/shared/types/commonTypes'

const Upsell = lazy(() => import('./v1/Upsell'))

const UPSELL_PAGE_MAP: TIdToPageMap = {
  [PageId.UPSELL_1]: Upsell,
}

const UpsellPage = (props: PageProps) => {
  const areSubscriptionsReady = useSelector(selectAreSubscriptionsReady)

  const PageComponent = UPSELL_PAGE_MAP[props.pageId]

  useGetSubscriptions({
    tags: SubscriptionTag.NO_TAX,
    screenName: ScreenName.UPSELL_OFFER,
    subscriptionType: SubscriptionListType.SECONDARY,
  })

  if (!areSubscriptionsReady) return <Spinner />

  return <PageComponent {...props} />
}

export default UpsellPage
